module.exports = __webpack_public_path__ + "static/intercom-integration4-5fdeea3c7e5a788fae22f1c299b253b6.png";